import { firebaseSdk } from './firebaseSdk'

// TODO: delete this
export const auth = firebaseSdk.auth && firebaseSdk.auth()
